import { useState, useMemo } from 'react'
import { ShippingOrder } from '../DeShippingTableWrapper'

export interface TabConfig {
  key: string
  label: string
  filter: (order: ShippingOrder) => boolean
}

export interface UseOrderTabsReturn {
  activeTab: string
  setActiveTab: (tab: string) => void
  tabConfig: TabConfig[]
  getFilteredOrders: (orders: ShippingOrder[]) => ShippingOrder[]
  getTabCounts: (orders: ShippingOrder[]) => Record<string, number>
}

// Tab configuration with filter functions
const TAB_CONFIG: TabConfig[] = [
  {
    key: 'all',
    label: 'All',
    filter: (order: ShippingOrder) => true
  },
  {
    key: 'needs_assignment',
    label: 'Needs Assignment',
    filter: (order: ShippingOrder) => order.assigned_items < order.total_items
  },
  {
    key: 'pending_review',
    label: 'Pending Review',
    filter: (order: ShippingOrder) => (order.pending_review_items || 0) > 0
  },
  {
    key: 'active_orders',
    label: 'Active Orders',
    filter: (order: ShippingOrder) => order.assigned_items === order.total_items
  },
  {
    key: 'declined',
    label: 'Declined',
    filter: (order: ShippingOrder) => (order.declined_items || 0) > 0
  }
]

export const useOrderTabs = (): UseOrderTabsReturn => {
  const [activeTab, setActiveTab] = useState('all')

  const getFilteredOrders = useMemo(() => {
    return (orders: ShippingOrder[]) => {
      const activeTabConfig = TAB_CONFIG.find(tab => tab.key === activeTab)
      if (!activeTabConfig) return orders
      
      return orders.filter(activeTabConfig.filter)
    }
  }, [activeTab])

  const getTabCounts = useMemo(() => {
    return (orders: ShippingOrder[]) => {
      const counts: Record<string, number> = {}
      
      TAB_CONFIG.forEach(tab => {
        counts[tab.key] = orders.filter(tab.filter).length
      })
      
      return counts
    }
  }, [])

  return {
    activeTab,
    setActiveTab,
    tabConfig: TAB_CONFIG,
    getFilteredOrders,
    getTabCounts
  }
}